import React, { Component } from "react";
import { withRouter } from "./withRouter";
import { tableFromIPC } from "apache-arrow";
import { Typography,Box, Stack, Select, 
    FormControl, InputLabel, MenuItem, Card, CardContent, TextField
 } from "@mui/material";

export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];

  
  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}
const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};

const PARTY_COLOURS = {
    nat:  "#0056A8" ,
    act: "#FFD700" ,
    nzf:"#000000" ,
};

const possibleAreas = [
  { area_name: "All", area_id: null },
  { area_name: "Auckland Central", area_id: 1 },
  { area_name: "Banks Peninsula", area_id: 2 },
  { area_name: "Botany", area_id: 3 },
  { area_name: "Christchurch Central", area_id: 4 },
  { area_name: "Christchurch East", area_id: 5 },
  { area_name: "Coromandel", area_id: 6 },
  { area_name: "Dunedin", area_id: 7 },
  { area_name: "East Cape", area_id: 8 },
  { area_name: "East Coast Bays", area_id: 9 },
  { area_name: "Epsom", area_id: 10 },
  { area_name: "Glendene", area_id: 11 },
  { area_name: "Hamilton East", area_id: 12 },
  { area_name: "Hamilton West", area_id: 13 },
  { area_name: "Henderson", area_id: 14 },
  { area_name: "Hutt South", area_id: 15 },
  { area_name: "Ilam", area_id: 16 },
  { area_name: "Invercargill", area_id: 17 },
  { area_name: "Kaikōura", area_id: 18 },
  { area_name: "Kaipara ki Mahurangi", area_id: 19 },
  { area_name: "Kapiti", area_id: 20 },
  { area_name: "Kenepuru", area_id: 21 },
  { area_name: "Māngere", area_id: 22 },
  { area_name: "Manurewa", area_id: 23 },
  { area_name: "Maungakiekie", area_id: 24 },
  { area_name: "Mt Albert", area_id: 25 },
  { area_name: "Mt Maunganui", area_id: 26 },
  { area_name: "Mt Roskill", area_id: 27 },
  { area_name: "Napier", area_id: 28 },
  { area_name: "Nelson", area_id: 29 },
  { area_name: "New Plymouth", area_id: 30 },
  { area_name: "North Shore", area_id: 31 },
  { area_name: "Northcote", area_id: 32 },
  { area_name: "Northland", area_id: 33 },
  { area_name: "Ōtāhuhu", area_id: 34 },
  { area_name: "Pakuranga", area_id: 35 },
  { area_name: "Palmerston North", area_id: 36 },
  { area_name: "Papakura", area_id: 37 },
  { area_name: "Port Waikato", area_id: 38 },
  { area_name: "Rangitata", area_id: 39 },
  { area_name: "Rangitīkei", area_id: 40 },
  { area_name: "Remutaka", area_id: 41 },
  { area_name: "Rotorua", area_id: 42 },
  { area_name: "Selwyn", area_id: 43 },
  { area_name: "Southland", area_id: 44 },
  { area_name: "Taieri", area_id: 45 },
  { area_name: "Takanini", area_id: 46 },
  { area_name: "Tāmaki", area_id: 47 },
  { area_name: "Taranaki-King Country", area_id: 48 },
  { area_name: "Taupō", area_id: 49 },
  { area_name: "Tauranga", area_id: 50 },
  { area_name: "Tukituki", area_id: 51 },
  { area_name: "Upper Harbour", area_id: 52 },
  { area_name: "Waikato", area_id: 53 },
  { area_name: "Waimakariri", area_id: 54 },
  { area_name: "Wairarapa", area_id: 55 },
  { area_name: "Waitākere", area_id: 56 },
  { area_name: "Waitaki", area_id: 57 },
  { area_name: "Wellington Bays", area_id: 58 },
  { area_name: "Wellington North", area_id: 59 },
  { area_name: "West Coast-Tasman", area_id: 60 },
  { area_name: "Whanganui", area_id: 61 },
  { area_name: "Whangaparāoa", area_id: 62 },
  { area_name: "Whangārei", area_id: 63 },
  { area_name: "Wigram", area_id: 64 }
];

const POLICY_LABELS = {
  health_importance_p: "Fixing the Health System",
  maori_importance_p: "Managing Māori Issues",
  invest_importance_p: "Investing in Transport and Infrastructure",
  crime_importance_p: "Controlling Crime",
  col_importance_p: "Managing the Cost of Living",
  ed_importance_p: "Improving Education",
};
const POLICY_COL_LABEL = {
  health_importance_p: "health",
  maori_importance_p: "maori",
  invest_importance_p: "invest",
  crime_importance_p: "crime",
  col_importance_p: "col",
  ed_importance_p: "ed",
};



class PolicyView extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "constituency",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.constituencyMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
      chosenDemog:"Gender",
      scatterDemogsRows:null,
      chosenGender:null,
      chosenAge:null,
      chosenEthnicity:null,
      chosenEducation:null,
      chosenPV:null,
      chosenElectorate:null
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
  };
  run();
}


   componentDidUpdate(prevProps, prevState) {
 
    const chosenGenderChanged      = prevState.chosenGender !== this.state.chosenGender;
    const chosenAgeChanged      = prevState.chosenAge !== this.state.chosenAge;
    const chosenEthnicityChanged      = prevState.chosenEthnicity !== this.state.chosenEthnicity;
    const chosenEducationChanged = prevState.chosenEducation !== this.state.chosenEducation;
    const chosenPVChanged      = prevState.chosenPV !== this.state.chosenPV;
    const chosenElectorateChanged      = prevState.chosenElectorate !== this.state.chosenElectorate;
    const filtersChanged = chosenGenderChanged || chosenAgeChanged || chosenEthnicityChanged ||chosenPVChanged || chosenElectorateChanged || chosenEducationChanged


    if (filtersChanged) {
        const run = async () => {
    await this.fetchMetrics("national", this.state.chosenElectorate, true);
    };
    run();
    }
    
  }

 
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    const keysBody = [
  "ed_importance_p",
  "health_importance_p",
  "col_importance_p",
  "crime_importance_p",
  "maori_importance_p",
  "invest_importance_p",
  "gov_well_ed_tot",
  "gov_poor_ed_tot",
  "gov_dontknow_ed",
  "gov_well_health_tot",
  "gov_poor_health_tot",
  "gov_dontknow_health",
  "gov_well_col_tot",
  "gov_poor_col_tot",
  "gov_dontknow_col",
  "gov_well_crime_tot",
  "gov_poor_crime_tot",
  "gov_dontknow_crime",
  "gov_well_maori_tot",
  "gov_poor_maori_tot",
  "gov_dontknow_maori",
  "gov_well_invest_tot",
  "gov_poor_invest_tot",
  "gov_dontknow_invest",
  "nat_p_col_poor",
  "nat_p_col_well",
  "act_p_col_poor",
  "act_p_col_well",
  "nzf_p_col_poor",
  "nzf_p_col_well",
  "nat_p_crime_poor",
  "nat_p_crime_well",
  "act_p_crime_poor",
  "act_p_crime_well",
  "nzf_p_crime_poor",
  "nzf_p_crime_well",
  "nat_p_ed_poor",
  "nat_p_ed_well",
  "act_p_ed_poor",
  "act_p_ed_well",
  "nzf_p_ed_poor",
  "nzf_p_ed_well",
  "nat_p_health_poor",
  "nat_p_health_well",
  "act_p_health_poor",
  "act_p_health_well",
  "nzf_p_health_poor",
  "nzf_p_health_well",
  "nat_p_invest_poor",
  "nat_p_invest_well",
  "act_p_invest_poor",
  "act_p_invest_well",
  "nzf_p_invest_poor",
  "nzf_p_invest_well",
  "nat_p_maori_poor",
  "nat_p_maori_well",
  "act_p_maori_poor",
  "act_p_maori_well",
  "nzf_p_maori_poor",
  "nzf_p_maori_well",
];
                
    let turnout_weight
    turnout_weight = "n_raked"

   

    const body = {
      groupKeys: keysBody,
      filters: {
      gender: this.state.chosenGender ?? null,     
      age: this.state.chosenAge ?? null,            
      ethnicity: this.state.chosenEthnicity ?? null,
      education: this.state.chosenEducation ?? null,
      vote_2023: this.state.chosenPV ?? null,     
    },
      constCode: constCode,
      turnout_weight:turnout_weight
    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/policy_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
    
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }


     handlechosenGenderChange     = (val) => this.setState({ chosenGender: val });
 handlechosenAgeChange     = (val) => this.setState({ chosenAge: val });
 handlechosenEthnicityChange     = (val) => this.setState({ chosenEthnicity: val });
 
 handlechosenEducationChange     = (val) => this.setState({ chosenEducation: val });
 handlechosenPVChange     = (val) => this.setState({ chosenPV: val });
 handlechosenElectorateChange     = (val) => {this.setState({ chosenElectorate: val })};
   


  render() {

    const {
    //   isPanelOpen,
       metricRows

    } = this.state;
    let policies
    if(metricRows){
 const row = metricRows[0];


  // extract relevant fields
  policies = Object.keys(POLICY_LABELS)
    .map((k) => (
        {
      key: k,
      label: POLICY_LABELS[k],
      importance: row[`${POLICY_COL_LABEL[k]}_importance_p`] ?? 0,
      poor: row[`gov_poor_${POLICY_COL_LABEL[k]}_tot`] ?? 0,
      well: row[`gov_well_${POLICY_COL_LABEL[k]}_tot`] ?? 0,
    }))
    .sort((a, b) => a.importance - b.importance);

    
        }
  // Helper to build blame/credit columns
   const buildPartyColumns = (metricRows, policyKey) => {
    const parties = ["nat", "act", "nzf"];

    // Extract blame values
    const poor = parties.map((p) => ({
        party: p.toUpperCase(),
        val: metricRows[`${p}_p_${POLICY_COL_LABEL[policyKey]}_poor`],
        color: PARTY_COLOURS[p],
    }));

    // Extract credit values
    const well = parties.map((p) => ({
        party: p.toUpperCase(),
        val: metricRows[`${p}_p_${POLICY_COL_LABEL[policyKey]}_well`],
        color: PARTY_COLOURS[p],
    }));

    // Normalise values so they sum to 1
    const poorSum = poor.reduce((acc, curr) => acc + curr.val, 0);
    const wellSum = well.reduce((acc, curr) => acc + curr.val, 0);

    poor.forEach((entry) => {
        entry.val = poorSum ? (entry.val / poorSum )*100: 0;
    });

    well.forEach((entry) => {
        entry.val = wellSum ?( entry.val / wellSum*100) : 0;
    });

    // Sort descending
    poor.sort((a, b) => b.val - a.val);
    well.sort((a, b) => b.val - a.val);

    return { poor, well };
};
  
  return(
     <Box sx={{ height: "92vh", display: "flex", flexDirection: "column", width:'100%' }}>
        {/* HEADER (auto height, no flexGrow) */}
        <Box
          sx={(theme) => ({
            height:"20%",
            px: 3, py: 3,
            display: "flex", alignItems: "center",
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : theme.palette.background.default,
            borderBottom: `1px solid ${theme.palette.divider}`,
            // no flexGrow, no % height here
          })}
        >
          {/* left: icon + text */}
          <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 4 }}>
    
            <Box>
              <Typography variant="h5" fontWeight={700}>Policy Scorecard</Typography>
              <Typography variant="body1" color="text.secondary">
                Select a demographic to view their policy-party scores
              </Typography>
            </Box>
                    <TextField
                        select
                        label="Gender"
                        size="small"
                        value={this.state.chosenGender}
                        onChange={(e) => this.handlechosenGenderChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="M">Male</MenuItem>
                        <MenuItem value="F">Female</MenuItem>
                        </TextField>

                        <TextField
                        select
                        label="Age"
                        size="small"
                        value={this.state.chosenAge}
                        onChange={(e) => this.handlechosenAgeChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="Young">Young</MenuItem>
                        <MenuItem value="Middle">Middle</MenuItem>
                        <MenuItem value="Old">Old</MenuItem>
                        </TextField>

                                        
                        <TextField
                        select
                        label="Education"
                        size="small"
                        value={this.state.chosenEducation}
                        onChange={(e) => this.handlechosenEducationChange?.(e.target.value)}
                        sx={{ mt: 3, minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="High">High</MenuItem>
                        <MenuItem value="Mid">Mid</MenuItem>
                        <MenuItem value="Low">Low</MenuItem>
                        </TextField>

                        <TextField
                        select
                        label="Ethnicity"
                        size="small"
                        value={this.state.chosenEthnicity}
                        onChange={(e) => this.handlechosenEthnicityChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="Asian only">Asian only</MenuItem>
                        <MenuItem value="European only">European only</MenuItem>
                        <MenuItem value="European/Māori">European/Māori</MenuItem>
                        <MenuItem value="Māori only">Māori only</MenuItem>
                        <MenuItem value="Pacific Peoples only">Other</MenuItem>
                        </TextField>

                        <TextField
                        select
                        label="2023 Vote"
                        size="small"
                        value={this.state.chosenPV}
                        onChange={(e) => this.handlechosenPVChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="ACT">ACT 2023</MenuItem>
                        <MenuItem value="GREEN">Green 2023</MenuItem>
                        <MenuItem value="LAB">Labour 2023</MenuItem>
                        <MenuItem value="NAT">National 2023</MenuItem>
                        <MenuItem value="NZF">NZF 2023</MenuItem>
                        <MenuItem value="TPM">TPM 2023</MenuItem>
                        <MenuItem value="OTH">Other 2023</MenuItem>
                        <MenuItem value="DNV">Did not vote</MenuItem>
                        </TextField>

                        <TextField
                        select
                        label="Electorate"
                        size="small"
                        value={this.state.chosenElectorate}
                        onChange={(e) => this.handlechosenElectorateChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        {possibleAreas.map((area) => (
                            <MenuItem key={area.area_name ?? "all"} value={area.area_id}>
                            {area.area_name}
                            </MenuItem>
                        ))}
                        </TextField>

          </Stack>
          
        </Box>

                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(6, 1fr)" },
                                            gap: 2,
                                            width: "100%",
                                            height:"100%"
                                        }}
                                        >
                                    {policies && policies.map((p, i) => {
                                                    const total = p.poor + p.well;
                                                    const poorPct = total > 0 ? (p.poor / total) * 100 : 0;
                                                    const wellPct = total > 0 ? (p.well / total) * 100 : 0;
                                                    const netWell = Math.round(p.well  - p.poor);

                                                    // 🔑 Build poor/well party columns for this policy
                                                    const partyCols = buildPartyColumns(metricRows[0], p.key); 
                                                    // (assuming metricRows[0] is your national row, or swap in the right area)

                                                    return (
                                                        <Card key={p.key} sx={{ display: "flex", flexDirection: "column" }}>
                                                        <CardContent
                                                                      sx={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        justifyContent: "flex-start",
                                                                        height: "100%",
                                                                      }}
                                                                    >
                                                                      {/* Top block (fixed min height for alignment) */}
                                                                      <Box
                                                                        sx={{
                                                                          minHeight: 180, // 👈 adjust this until all labels fit comfortably
                                                                          display: "flex",
                                                                          flexDirection: "column",
                                                                          alignItems: "center",
                                                                          justifyContent: "flex-start",
                                                                          textAlign: "center",
                                                                          px: 1,
                                                                        }}
                                                                      >
                                                                        <Typography variant="h4" fontWeight={700}>
                                                                          {i + 1}
                                                                        </Typography>
                                                                        <Typography variant="h6" sx={{ mb: 1 }}>
                                                                          {p.label}
                                                                        </Typography>
                                                                        <Typography variant="body2" color="text.secondary">
                                                                          Average Importance Ranking: {p.importance.toFixed(0)/100}
                                                                        </Typography>
                                                                      </Box>

                                                                      {/* Net Well bar (always in the same place) */}
                                                                      <Box
                                                                        sx={{
                                                                          width: "100%",
                                                                          mt: 2,
                                                                          mb: 2,
                                                                          flexShrink: 0, // 👈 ensures this doesn't move when other areas expand
                                                                        }}
                                                                      >
                                                                        <Typography
                                                                          variant="body2"
                                                                          sx={{ mt: 1, textAlign: "center", fontSize: 15 }}
                                                                        >
                                                                          <b>Net ’Well’</b> : {netWell > 0 ? `+${netWell}` : netWell}%
                                                                        </Typography>
                                                                        <Box sx={{ display: "flex", width: "100%", height: 20 }}>
                                                                          <Box sx={{ width: `${wellPct}%`, bgcolor: "lightgreen" }} />
                                                                          <Box sx={{ width: `${poorPct}%`, bgcolor: "tomato" }} />
                                                                        </Box>
                                                                        <Box
                                                                          sx={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            mt: 0.5,
                                                                            fontSize: "1rem",
                                                                          }}
                                                                        >
                                                                          <span>{p.well.toFixed(0)}%</span>
                                                                          <span>{p.poor.toFixed(0)}%</span>
                                                                        </Box>
                                                                      </Box>

                                                                      {/* Bottom section (takes remaining space if any) */}
                                                                      <Box sx={{ mt: "auto", width: "100%" }}>
                                                                        <Typography
                                                                          variant="body2"
                                                                          color="text.secondary"
                                                                          sx={{ textAlign: "center", mb: 1}}
                                                                        >
                                                                          Which party is responsible for this policy going:
                                                                        </Typography>

                                                                        {/* Party blame/credit */}
                                                                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
                                                                          {/* Well column */}
                                                                          <Box>
                                                                            <Typography variant="caption" sx={{ fontStyle: "italic" }}>
                                                                              Well
                                                                            </Typography>
                                                                            {partyCols.well.map((row) => (
                                                                              <Box
                                                                                key={row.party}
                                                                                sx={{
                                                                                  bgcolor: row.color,
                                                                                  color: row.party === "ACT" ? "#818589" : "white",
                                                                                  p: 1,
                                                                                  textAlign: "center",
                                                                                  fontWeight: "bold",
                                                                                  mb: 0.5,
                                                                                }}
                                                                              >
                                                                                {row.party} {row.val.toFixed(0)}%
                                                                              </Box>
                                                                            ))}
                                                                          </Box>

                                                                          {/* Poor column */}
                                                                          <Box>
                                                                            <Typography variant="caption" sx={{ fontStyle: "italic" }}>
                                                                              Poorly
                                                                            </Typography>
                                                                            {partyCols.poor.map((row) => (
                                                                              <Box
                                                                                key={row.party}
                                                                                sx={{
                                                                                  bgcolor: row.color,
                                                                                  color: row.party === "ACT" ? "#818589" : "white",
                                                                                  p: 1,
                                                                                  textAlign: "center",
                                                                                  fontWeight: "bold",
                                                                                  mb: 0.5,
                                                                                }}
                                                                              >
                                                                                {row.party} {row.val.toFixed(0)}%
                                                                              </Box>
                                                                            ))}
                                                                          </Box>
                                                                        </Box>
                                                                      </Box>
                                                                    </CardContent>

                                                        </Card>
                                                    );
                                                    })}

                </Box>
  
        
 
    
      </Box>
  

  )
}


  }

export default withRouter(PolicyView);